export enum Directed {
    OWN = 'OWN',
    OTHER = 'OTHER',
}
export type TriggerOption = {
    operation: 'gt' | 'eq' | 'in';
    value: string | number | boolean;
};

export const config_phase3: {
    [attrName: string]:
        | {
              shortText: string;
              fullText: string;
              triggerAnswerFromParent?: TriggerOption;
              affirmativeOption?: string;
              followupParent: string | null;
              directedFrom?: Directed;
              groupWith?: string;
              low?: string;
              high?: string;
          }
        | undefined;
} = {
    "phase3a.popup.0.formality": {
        "shortText": "Formality",
        "fullText": "How formal is the officer's conduct when interacting with the civilians?",
        "low": "Very Informal",
        "high": "Very Formal",
        "followupParent": null
    },
    "phase3a.popup.0.empathy": {
        "shortText": "Empathy",
        "fullText": "Does the officer express empathy for the civilian's actions (i.e. does the officer indicate that they understand and relate to what the civilian is feeling)?",
        "low": "Very Unempathetic",
        "high": "Very Empathetic",
        "followupParent": null
    },
    "phase3a.popup.1.formality": {
        "shortText": "Formality",
        "fullText": "How formal is the officer's conduct when interacting with the civilians?",
        "low": "Very Informal",
        "high": "Very Formal",
        "followupParent": null
    },
    "phase3a.popup.1.empathy": {
        "shortText": "Empathy",
        "fullText": "Does the officer express empathy for the civilian's actions (i.e. does the officer indicate that they understand and relate to what the civilian is feeling)?",
        "low": "Very Unempathetic",
        "high": "Very Empathetic",
        "followupParent": null
    },
    "phase3a.popup.2.empathy": {
        "shortText": "Empathy",
        "fullText": "Does the officer express empathy for the civilian's actions (i.e. does the officer indicate that they understand and relate to what the civilian is feeling)?",
        "low": "Very Unempathetic",
        "high": "Very Empathetic",
        "followupParent": null
    },
    "phase3a.popup.2.formality": {
        "shortText": "Formality",
        "fullText": "How formal is the officer's conduct when interacting with the civilians?",
        "low": "Very Informal",
        "high": "Very Formal",
        "followupParent": null
    },
    "phase3a.popup.0.fear": {
        "shortText": "Fear",
        "fullText": "Does the {{label_type}} express fear?",
        "low": "Very Secure",
        "high": "Very Fearful",
        "followupParent": null
    },
    "phase3a.popup.0.feartype": {
        "shortText": "Fear Type",
        "fullText": "If fear is greater than 3, which type of fear?",
        "followupParent": "phase3a.popup.0.fear",
        "triggerAnswerFromParent": {
            "operation": "gt",
            "value": 3
        },
        "directedFrom": Directed.OWN,
        "groupWith": "phase3a.popup.0.fear"
    },
    "phase3a.popup.0.anger": {
        "shortText": "Anger",
        "fullText": "Does the {{label_type}} express anger?",
        "low": "Very Calm",
        "high": "Very Angry",
        "followupParent": null
    },
    "phase3a.popup.0.threatening": {
        "shortText": "Threatening",
        "fullText": "Does the {{label_type}} appear threatening (i.e. intending to cause harm)?",
        "low": "Not threatening at all",
        "high": "Very Threatening",
        "followupParent": null
    },
    "phase3a.popup.0.offensiveness": {
        "shortText": "Offensiveness",
        "fullText": "Does the {{label_type}} act or behave offensively towards the {{opposing_label_type}}(s)?",
        "low": "No Offensiveness",
        "high": "Very Offensive",
        "followupParent": null
    },
    "phase3a.popup.0.biasandhate": {
        "shortText": "Bias or Hate",
        "fullText": "If offensiveness is greater than 3, to what extent do you believe the {{label_type}}'s offensive behavior was motivated by bias or hate?",
        "low": "No bias or hate",
        "high": "Clearly motivated by bias or hate",
        "followupParent": "phase3a.popup.0.offensiveness",
        "triggerAnswerFromParent": {
            "operation": "gt",
            "value": 3
        },
        "directedFrom": Directed.OWN,
        "groupWith": "phase3a.popup.0.offensiveness"
    },
    "phase3a.popup.0.warmth": {
        "shortText": "Warmth",
        "fullText": "Does the {{label_type}} act warm or cold towards the {{opposing_label_type}}?",
        "low": "Very Cold",
        "high": "Very Warm",
        "followupParent": null
    },
    "phase3a.popup.0.respectful": {
        "shortText": "Respectful",
        "fullText": "Does the {{label_type}} act respectfully or disrespectfully towards the {{opposing_label_type}}?",
        "low": "Very Disrespectful",
        "high": "Very Respectful",
        "followupParent": null
    },
    "phase3a.popup.0.doesnotappear": {
        "shortText": "Does Not Appear",
        "fullText": "Does not appear in the previous section",
        "followupParent": null
    },
    "phase3a.popup.0.doesnotcontribute":{
        "shortText": "Does Not Contribute",
        "fullText": "Does not contribute meaningfully to the previous section",
        "followupParent": null,
        "groupWith": "phase3a.popup.0.doesnotappear"
    },
    "phase3a.popup.0.emotionopen": {
        "shortText": "Emotion Open",
        "fullText": "Please describe the key words, facial expressions, body language, or actions that informed your emotional ratings of the {{label_type}}",
        "groupWith": "phase3a.popup.0.emotionother",
        "followupParent": null
    },
    "phase3a.popup.0.emotionother": {
        "shortText": "Emotion Other",
        "fullText": "What other emotions or attitudes would you say the {{label_type}} was expressing toward the {{opposing_label_type}}(s)?",
        "followupParent": null
    },
    "phase3a.popup.1.fear": {
        "shortText": "Fear",
        "fullText": "Does the {{label_type}} express fear?",
        "low": "Very Secure",
        "high": "Very Fearful",
        "followupParent": null
    },
    "phase3a.popup.1.feartype": {
        "shortText": "Fear Type",
        "fullText": "If fear is greater than 3, which type of fear?",
        "followupParent": "phase3a.popup.1.fear",
        "triggerAnswerFromParent": {
            "operation": "gt",
            "value": 3
        },
        "directedFrom": Directed.OWN,
        "groupWith": "phase3a.popup.1.fear"
    },
    "phase3a.popup.1.anger": {
        "shortText": "Anger",
        "fullText": "Does the {{label_type}} express anger?",
        "low": "Very Calm",
        "high": "Very Angry",
        "followupParent": null
    },
    "phase3a.popup.1.threatening": {
        "shortText": "Threatening",
        "fullText": "Does the {{label_type}} appear threatening (i.e. intending to cause harm or damage)?",
        "low": "Not threatening at all",
        "high": "Very Threatening",
        "followupParent": null
    },
    "phase3a.popup.1.offensiveness": {
        "shortText": "Offensiveness",
        "fullText": "Does the {{label_type}} act or behave offensively towards the {{opposing_label_type}}(s)?",
        "low": "No Offensiveness",
        "high": "Very Offensive",
        "followupParent": null
    },
    "phase3a.popup.1.biasandhate": {
        "shortText": "Bias or Hate",
        "fullText": "If offensiveness is greater than 3, to what extent do you believe the {{label_type}}'s offensive behavior was motivated by bias or hate?",
        "low": "No bias or hate",
        "high": "Clearly motivated by bias or hate",
        "followupParent": "phase3a.popup.1.offensiveness",
        "triggerAnswerFromParent": {
            "operation": "gt",
            "value": 3
        },
        "directedFrom": Directed.OWN,
        "groupWith": "phase3a.popup.1.offensiveness"
    },
    "phase3a.popup.1.warmth": {
        "shortText": "Warmth",
        "fullText": "Does the {{label_type}} act warm towards the {{opposing_label_type}}?",
        "low": "Very Cold",
        "high": "Very Warm",
        "followupParent": null
    },
    "phase3a.popup.1.respectful": {
        "shortText": "Respectful",
        "fullText": "Does the {{label_type}} act respectfully towards the {{opposing_label_type}}?",
        "low": "Very Disrespectful",
        "high": "Very Respectful",
        "followupParent": null
    },
    "phase3a.popup.1.doesnotappear": {
        "shortText": "Does Not Appear",
        "fullText": "Does not appear in the previous section",
        "followupParent": null
    },
    "phase3a.popup.1.doesnotcontribute":{
        "shortText": "Does Not Contribute",
        "fullText": "Does not contribute meaningfully to the previous section",
        "followupParent": null,
        "groupWith": "phase3a.popup.1.doesnotappear"
    },
    "phase3a.popup.1.emotionopen": {
        "shortText": "Emotion Open",
        "fullText": "Please describe the key words, facial expressions, body language, or actions that informed your emotional ratings of the {{label_type}}.",
        "groupWith": "phase3a.popup.1.emotionother",
        "followupParent": null
    },
    "phase3a.popup.1.emotionother": {
        "shortText": "Emotion Other",
        "fullText": "What other emotions or attitudes would you say the {{label_type}} was expressing toward the {{opposing_label_type}}(s)?",
        "followupParent": null
    },
    "phase3a.popup.2.fear": {
        "shortText": "Fear",
        "fullText": "Does the {{label_type}} express fear?",
        "low": "Very Secure",
        "high": "Very Fearful",
        "followupParent": null
    },
    "phase3a.popup.2.feartype": {
        "shortText": "Fear Type",
        "fullText": "If fear is greater than 3, which type of fear?",
        "followupParent": "phase3a.popup.2.fear",
        "triggerAnswerFromParent": {
            "operation": "gt",
            "value": 3
        },
        "directedFrom": Directed.OWN,
        "groupWith": "phase3a.popup.2.fear"
    },
    "phase3a.popup.2.anger": {
        "shortText": "Anger",
        "fullText": "Does the {{label_type}} express anger?",
        "low": "Very Calm",
        "high": "Very Angry",
        "followupParent": null
    },
    "phase3a.popup.2.threatening": {
        "shortText": "Threatening",
        "fullText": "Does the {{label_type}} appear threatening (i.e. intending to cause harm or damage)?",
        "low": "Not threatening at all",
        "high": "Very Threatening",
        "followupParent": null
    },
    "phase3a.popup.2.offensiveness": {
        "shortText": "Offensiveness",
        "fullText": "Does the {{label_type}} act or behave offensively towards the {{opposing_label_type}}(s)?",
        "low": "No Offensiveness",
        "high": "Very Offensive",
        "followupParent": null
    },
    "phase3a.popup.2.biasandhate": {
        "shortText": "Bias or Hate",
        "fullText": "If offensiveness is greater than 3, to what extent do you believe the {{label_type}}'s offensive behavior was motivated by bias or hate?",
        "low": "No bias or hate",
        "high": "Clearly motivated by bias or hate",
        "followupParent": "phase3a.popup.2.offensiveness",
        "triggerAnswerFromParent": {
            "operation": "gt",
            "value": 3
        },
        "directedFrom": Directed.OWN,
        "groupWith": "phase3a.popup.2.offensiveness"
    },
    "phase3a.popup.2.warmth": {
        "shortText": "Warmth",
        "fullText": "Does the {{label_type}} act warm towards the {{opposing_label_type}}?",
        "low": "Very Cold",
        "high": "Very Warm",
        "followupParent": null
    },
    "phase3a.popup.2.respectful": {
        "shortText": "Respectful",
        "fullText": "Does the {{label_type}} act respectfully towards the {{opposing_label_type}}?",
        "low": "Very Disrespectful",
        "high": "Very Respectful",
        "followupParent": null
    },
    "phase3a.popup.2.doesnotappear": {
        "shortText": "Does Not Appear",
        "fullText": "Does not appear in the previous section",
        "followupParent": null
    },
    "phase3a.popup.2.doesnotcontribute":{
        "shortText": "Does Not Contribute",
        "fullText": "Does not contribute meaningfully to the previous section",
        "followupParent": null,
        "groupWith": "phase3a.popup.2.doesnotappear"
    },
    "phase3a.popup.2.emotionopen": {
        "shortText": "Emotion Open",
        "fullText": "Please describe the key words, facial expressions, body language, or actions that informed your emotional ratings of the {{label_type}}.",
        "groupWith": "phase3a.popup.2.emotionother",
        "followupParent": null
    },
    "phase3a.popup.2.emotionother": {
        "shortText": "Emotion Other",
        "fullText": "What other emotions or attitudes would you say the {{label_type}} was expressing toward the {{opposing_label_type}}(s)?",
        "followupParent": null
    },
    "phase3a.sidebar.clarity": {
        "shortText": "Clarity",
        "fullText": "Is there a time when the civilian cannot understand or is having difficulty understanding an officer?",
        "followupParent": null
    },
    "phase3a.sidebar.apologyciv": {
        "shortText": "Apology",
        "fullText": "Does the civilian apologize or express any regret for the violation?",
        "followupParent": null
    },
    "phase3a.sidebar.thank": {
        "shortText": "Thank",
        "fullText": "Does the civilian thank an officer?",
        "followupParent": null
    },
    "phase3a.sidebar.hands": {
        "shortText": "Hands",
        "fullText": "Are the civilian's hands visible to the officer when an officer first approaches the vehicle?",
        "followupParent": null
    },
    "phase3a.sidebar.handswheel": {
        "shortText": "Hands Wheel",
        "fullText": "Are the hands on the steering wheel?",
        "followupParent": "phase3a.sidebar.hands",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.pullsafely": {
        "shortText": "Pull Safely",
        "fullText": "Does an officer state that the driver did not pull over as requested or was delayed in doing so?",
        "followupParent": null
    },
    "phase3a.sidebar.movements": {
        "shortText": "Movements",
        "fullText": "Does the civilian make any sudden movements with their hands that an officer might perceive as dangerous?",
        "followupParent": null
    },
    "phase3a.sidebar.movementscommunication": {
        "shortText": "Movements Communication",
        "fullText": "Does the civilian tell an officer in advance about the movements they are going to make or ask permission to move? (i.e., \u201cI am going to reach into the glove box\u2026\u201d OR \u201cIs it OK if I?\u201d)",
        "followupParent": null
    },
    "phase3a.sidebar.movementdirections": {
        "shortText": "Movement Directions",
        "fullText": "Does an officer give the civilian any directions about how to move or not move (e.g., \u201cKeep your hands on the wheel\u201d or \u201cReach slowly into the dash\u201d)",
        "followupParent": null
    },
    "phase3a.sidebar.movementcomply": {
        "shortText": "Movement Comply",
        "fullText": "Does the civilian comply with this movement direction?",
        "followupParent": "phase3a.sidebar.movementdirections",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.provideregistration": {
        "shortText": "Provide Registration",
        "fullText": "Does the civilian provide registration?",
        "followupParent": null
    },
    "phase3a.sidebar.providedl": {
        "shortText": "Provide DL",
        "fullText": "Does the civilian provide their driver's license or ID?",
        "followupParent": null
    },
    "phase3a.sidebar.acknowledgefault": {
        "shortText": "Acknowledge Fault",
        "fullText": "Does the civilian acknowledge committing a violation or crime?",
        "followupParent": null
    },
    "phase3a.sidebar.challengeappropriateness": {
        "shortText": "Challenge Appropriateness",
        "fullText": "Does the civilian challenge either the appropriateness/legitimacy of the stop (e.g., \"Why did you pull me over, I did nothing wrong!\") or the authority of the officer (e.g., \"I don't have to listen to you\")?",
        "followupParent": null
    },
    "phase3a.sidebar.perspectiveonleadup": {
        "shortText": "Perspective on Lead Up",
        "fullText": "Does the civilian provide an explanation or justification of their behavior that preceded or led to the stop?",
        "followupParent": null
    },
    "phase3a.sidebar.justification": {
        "shortText": "Justification",
        "fullText": "Does an officer provide an opportunity for the person to give an explanation or justification of their behavior that preceded or led to the stop (e.g., why they were doing what they were doing before they got pulled over)?",
        "followupParent": null
    },
    "phase3a.sidebar.detailaskoff": {
        "shortText": "Detail Ask Officer",
        "fullText": "Does an officer ask for clarification of details about the civilian\u2019s explanation?",
        "followupParent": null
    },
    "phase3a.sidebar.options": {
        "shortText": "Options",
        "fullText": "Does an officer give an explanation of the civilian\u2019s options about how to proceed during (e.g., they say \u201cYou can wait here for your mom to pick up the car or I will have to impound the vehicle\u201d) or a concluding description of the process and next steps after the stop (e.g., officer explains citation, next steps for court or payment, or clarifies any required actions)?",
        "followupParent": null
    },
    "phase3a.sidebar.stopcomprehensioncheck": {
        "shortText": "Stop Comprehension Check",
        "fullText": "Does an officer ask whether the civilian understood why they had been stopped? (Note: This DOES NOT include asking \u201cDo you know why I pulled you over?\u201d)",
        "followupParent": null
    },
    "phase3a.sidebar.enforcementcomprehensioncheck": {
        "shortText": "Enforcement Comprehension Check",
        "fullText": "Does an officer ask whether the civilian understood the enforcement action that was taken (e.g., the citation, warning, seizure, arrest, etc)?",
        "followupParent": null
    },
    "phase3a.sidebar.detain": {
        "shortText": "Detain",
        "fullText": "Is the civilian being detained in a way that goes beyond the routine detention of a traffic stop?",
        "followupParent": null
    },
    "phase3a.sidebar.detaintype": {
        "shortText": "Detain Type",
        "fullText": "How are they detained?",
        "followupParent": "phase3a.sidebar.detain",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.yell": {
        "shortText": "Yell",
        "fullText": "Does the civilian yell at an officer?",
        "followupParent": null
    },
    "phase3a.sidebar.verbalattack": {
        "shortText": "Verbal Attack",
        "fullText": "Does the civilian insult or verbally attack an officer?",
        "followupParent": null
    },
    "phase3a.sidebar.hatespeech": {
        "shortText": "Hate Speech",
        "fullText": "Does the civilian use hate speech (e.g., racist, sexist, or homophobic language)?",
        "followupParent": null
    },
    "phase3a.sidebar.hatespeechopen": {
        "shortText": "Hate Speech Open",
        "fullText": "Can you please explain the situation in which the hate speech was used and why you consider the language to be hate-based?",
        "followupParent": "phase3a.sidebar.hatespeech",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.cellphone": {
        "shortText": "Cell Phone",
        "fullText": "Does the civilian use their cell phone?",
        "followupParent": null
    },
    "phase3a.sidebar.cellphoneuse": {
        "shortText": "Cell Phone use",
        "fullText": "How is the civilian using their cell phone? Choose all that apply",
        "followupParent": "phase3a.sidebar.cellphone",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.threatenviolence": {
        "shortText": "Threaten Violence",
        "fullText": "Does the civilian threaten an officer with violence?",
        "followupParent": null
    },
    "phase3a.sidebar.violencefollowup": {
        "shortText": "Violence Type",
        "fullText": "Is this a verbal threat or physical intimidation?",
        "followupParent": "phase3a.sidebar.threatenviolence",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.leavevehicle": {
        "shortText": "Leave Vehicle",
        "fullText": "Does the civilian leave the vehicle?",
        "followupParent": null
    },
    "phase3a.sidebar.leavevehicleagainst": {
        "shortText": "Leave Vehicle Against",
        "fullText": "Does the civilian try to leave the vehicle against an officer\u2019s instructions?",
        "followupParent": null
    },
    "phase3a.sidebar.force": {
        "shortText": "Force",
        "fullText": "Does the civilian use any force against an officer?",
        "followupParent": null
    },
    "phase3a.sidebar.forcetype": {
        "shortText": "Force Type",
        "fullText": "What type of force?",
        "followupParent": "phase3a.sidebar.force",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.paroleprobation": {
        "shortText": "Parole Probation",
        "fullText": "Is the civilian on probation or parole?",
        "followupParent": null
    },
    "phase3a.sidebar.paroleask": {
        "shortText": "Parole Ask",
        "fullText": "Does an officer ask whether the civilian is on probation or parole?",
        "followupParent": null
    },
    "phase3a.sidebar.weaponinvehicle": {
        "shortText": "Weapon in Vehicle",
        "fullText": "Does the civilian appear to have a weapon in their vehicle or otherwise in their immediate possession?",
        "followupParent": null
    },
    "phase3a.sidebar.weapontype": {
        "shortText": "Weapon Type",
        "fullText": "What kind of weapon?",
        "followupParent": "phase3a.sidebar.weaponinvehicle",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.citation": {
        "shortText": "Citation",
        "fullText": "Is the civilian issued a citation or written warning?",
        "followupParent": null
    },
    "phase3a.sidebar.stateexactwarning/citation": {
        "shortText": "State Exact Warning/Citation",
        "fullText": "Does any officer state the exact warning or citation they give to the civilian?",
        "followupParent": "phase3a.sidebar.citation",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.citation_open": {
        "shortText": "Citation Open",
        "fullText": "Please briefly describe what citation or warning they were given:",
        "followupParent": "phase3a.sidebar.stateexactwarning/citation",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.impound": {
        "shortText": "Impound",
        "fullText": "Is the civilian's car impounded?",
        "followupParent": null
    },
    "phase3a.sidebar.legalcounsel": {
        "shortText": "Legal Counsel",
        "fullText": "Does the civilian ever ask for legal counsel?",
        "followupParent": null
    },
    "phase3a.sidebar.interrupt": {
        "shortText": "Interrupt",
        "fullText": "At any point in the stop, does the civilian interrupt or attempt to interrupt an officer when the officer is speaking?",
        "followupParent": null
    },
    "phase3a.sidebar.psychold": {
        "shortText": "Psych Hold",
        "fullText": "Do the police put the civilian on a psychiatric hold?",
        "followupParent": null
    },
    "phase3a.sidebar.patdownask": {
        "shortText": "Pat Down Ask",
        "fullText": "Does an officer ask permission to conduct a pat down?",
        "followupParent": null
    },
    "phase3a.sidebar.patdownpermissionfree": {
        "shortText": "Pat Down Permission Free",
        "fullText": "When the officer asked for permission to perfoem a pat down, did they use any of the following approaches? Select all that apply.",
        "followupParent": "phase3a.sidebar.patdownask",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.patdown": {
        "shortText": "Pat Down",
        "fullText": "Does an officer conduct a pat down of this civilian?",
        "followupParent": null
    },
    "phase3a.sidebar.patdownpermission": {
        "shortText": "Pat Down Permission",
        "fullText": "Does the civilian consent to a pat down?",
        "followupParent": "phase3a.sidebar.patdown",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.patdownpermissionexplicit": {
        "shortText": "Pat Down Permission Explicit",
        "fullText": "How did the civilian consent to a pat down?",
        "followupParent": "phase3a.sidebar.patdownpermission",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.contrabandfoundpatdown": {
        "shortText": "Contraband Found Pat Down",
        "fullText": "Was contraband found?",
        "followupParent": null
    },
    "phase3a.sidebar.contrabandtypepatdown": {
        "shortText": "Contraband Type Pat Down",
        "fullText": "What type of contraband?",
        "followupParent": null
    },
    "phase3a.sidebar.contrabandseizedpatdown": {
        "shortText": "Contraband Seized Pat Down",
        "fullText": "Was the contraband seized?",
        "followupParent": "phase3a.sidebar.contrabandfoundpatdown",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.searchperson": {
        "shortText": "Search Person",
        "fullText": "Does an officer search the civilian?",
        "followupParent": null
    },
    "phase3a.sidebar.searchpersonask": {
        "shortText": "Search Person Ask",
        "fullText": "Does an officer ask permission to conduct a search of the person?",
        "followupParent": null
    },
    "phase3a.sidebar.searchpersonpermfree": {
        "shortText": "Search Person Perm Free",
        "fullText": "When the officer asked for permission to search the person, did they use any of the following approaches? Select all that apply.",
        "followupParent": "phase3a.sidebar.searchpersonask",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.searchpersonpermission": {
        "shortText": "Search Person Permission",
        "fullText": "Did the civilian give permission to conduct a search of their person?",
        "followupParent": "phase3a.sidebar.searchperson",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.searchpersonpermissionexplicit": {
        "shortText": "Search Person Permission Explicit",
        "fullText": "How did the civilian give consent for the search? Choose all that apply:",
        "followupParent": "phase3a.sidebar.searchpersonpermission",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.contrabandfoundperson": {
        "shortText": "Contraband Found Person",
        "fullText": "Was any contraband found?",
        "followupParent": null
    },
    "phase3a.sidebar.contrabandtypeperson": {
        "shortText": "Contraband Type Person",
        "fullText": "What type of contraband?",
        "followupParent": null
    },
    "phase3a.sidebar.contrabandseizedperson": {
        "shortText": "Contraband Seized Person",
        "fullText": "Was the contraband seized?",
        "followupParent": "phase3a.sidebar.contrabandfoundperson",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.searchvehicle": {
        "shortText": "Search Vehicle",
        "fullText": "Does an officer conduct a search of the vehicle?",
        "followupParent": null
    },
    "phase3a.sidebar.searchask": {
        "shortText": "Search Ask",
        "fullText": "Does an officer ask permission to search the vehicle?",
        "followupParent": null
    },
    "phase3a.sidebar.searchpermfree": {
        "shortText": "Search Perm Free",
        "fullText": "When the officer asked for permission to search, did they use any of the following approaches? Select all that apply.",
        "followupParent": "phase3a.sidebar.searchask",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.searchpermission": {
        "shortText": "Search Permission",
        "fullText": "Did the driver give permission to conduct a search of the vehicle?",
        "followupParent": "phase3a.sidebar.searchvehicle",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.searchpermissionexplicit": {
        "shortText": "Search Permission Explicit",
        "fullText": "How did the driver give consent for the search? Choose all that apply:",
        "followupParent": "phase3a.sidebar.searchpermission",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.contrabandfoundvehicle": {
        "shortText": "Contraband Found Vehicle",
        "fullText": "Was any contraband found?",
        "followupParent": null
    },
    "phase3a.sidebar.contrabandtypevehicle": {
        "shortText": "Contraband Type Vehicle",
        "fullText": "What type of contraband?",
        "followupParent": null
    },
    "phase3a.sidebar.contrabandseizedvehicle": {
        "shortText": "Contraband Seized Vehicle",
        "fullText": "Was the contraband seized?",
        "followupParent": "phase3a.sidebar.contrabandfoundvehicle",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.reasonask": {
        "shortText": "Reason Ask",
        "fullText": "Does an officer ask the driver if they know why they have been stopped?",
        "followupParent": null
    },
    "phase3a.sidebar.reasongiven": {
        "shortText": "Reason Given",
        "fullText": "Does an officer provide the civilian with an explanation of why they were stopped?",
        "followupParent": null
    },
    "phase3a.sidebar.reasontype": {
        "shortText": "Reason Type",
        "fullText": "What is the reason for the stop that the officer gives to the civilian? Choose all that apply.",
        "followupParent": "phase3a.sidebar.reasongiven",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.ifspeedinga": {
        "shortText": "If Speeding A",
        "fullText": "What was the speed limit?",
        "followupParent": "phase3a.sidebar.reasontype",
        "triggerAnswerFromParent": {
            "operation": "in",
            "value": "Speeding"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.ifspeedingb": {
        "shortText": "If Speeding B",
        "fullText": "What was the reported speed?",
        "followupParent": "phase3a.sidebar.reasontype",
        "triggerAnswerFromParent": {
            "operation": "in",
            "value": "Speeding"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.ifspeedingc": {
        "shortText": "If Speeding C",
        "fullText": "Was this a school zone, work zone, or other safety zone?",
        "followupParent": "phase3a.sidebar.reasontype",
        "triggerAnswerFromParent": {
            "operation": "in",
            "value": "Speeding"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.reasonspecific": {
        "shortText": "Reason Specific",
        "fullText": "Does the officer's explanation give a specific reason for the stop, rather than one that is vague, circular, or nonsensical?",
        "followupParent": "phase3a.sidebar.reasongiven",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "affirmativeOption": "Yes — specific reason",
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.reasoncivilianspecific": {
        "shortText": "Reason Civilian Specific",
        "fullText": "In giving the reason, does the officer refer to this specific civilian's own actions or situation (e.g., “you were speeding”), rather than to drivers or people in general?",
        "followupParent": "phase3a.sidebar.reasongiven",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "affirmativeOption": "Yes",
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.reasonofficerintent": {
        "shortText": "Reason Officer Intent",
        "fullText": "Does the officer describe the reason in terms of their own intent or actions (e.g., “I want to make sure you get home safe”), rather than the department’s, the city’s, or the unit’s?",
        "followupParent": "phase3a.sidebar.reasongiven",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "affirmativeOption": "Yes",
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.reasoncare": {
        "shortText": "Reason Care",
        "fullText": "As part of that explanation, does the officer express care about the safety or well-being of this civilian, or about public safety generally? Note: Not a general statement of concern, but concern tied to the explanation of why they were stopped.",
        "followupParent": "phase3a.sidebar.reasongiven",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "affirmativeOption": "Yes",
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.reasoncarequalifier": {
        "shortText": "Reason Care Qualifier",
        "fullText": "Does either of the following apply to that statement of concern? Choose all that apply.",
        "followupParent": "phase3a.sidebar.reasongiven",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.reasonprompt": {
        "shortText": "Reason Prompt",
        "fullText": "What happened immediately before the officer gave the explanation? Choose all that apply.",
        "followupParent": "phase3a.sidebar.reasongiven",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.weaponask": {
        "shortText": "Weapon Ask",
        "fullText": "Does an officer ask whether the civilian has a weapon?",
        "followupParent": null
    },
    "phase3a.sidebar.duiask": {
        "shortText": "DUI Ask",
        "fullText": "Does an officer ask whether the civilian has been drinking or using drugs or is in possession of drugs or alcohol?",
        "followupParent": null
    },
    "phase3a.sidebar.sobrietytest": {
        "shortText": "Sobriety Test",
        "fullText": "Does an officer give the civilian a field sobriety test?",
        "followupParent": null
    },
    "phase3a.sidebar.stepoutask": {
        "shortText": "Step-out Ask",
        "fullText": "Does an officer direct the civilian to leave the vehicle?",
        "followupParent": null
    },
    "phase3a.sidebar.suspicionindicated": {
        "shortText": "Suspicion Indicated",
        "fullText": "Did an officer indicate anything that they observed during the stop that made them suspect the civilian might be involved in any crime other than a traffic infraction or equipment violation?",
        "followupParent": null
    },
    "phase3a.sidebar.suspicionopen": {
        "shortText": "Suspicion Open",
        "fullText": "What was the reason given for the suspicion?",
        "followupParent": "phase3a.sidebar.suspicionindicated",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.freetoleave": {
        "shortText": "Free to leave",
        "fullText": "Does an officer tell the civilian they are free to leave at the end of the stop?",
        "followupParent": null
    },
    "phase3a.sidebar.outofplace": {
        "shortText": "Out of Place",
        "fullText": "Does an officer say or do anything that indicates the officer believes the civilian should not be in the neighborhood/location where they were pulled over?",
        "followupParent": null
    },
    "phase3a.sidebar.investigationask": {
        "shortText": "Investigation Ask",
        "fullText": "Does an officer ask the civilian any other questions that seem to be aimed at investigating whether the civilian may be guilty of a crime/infraction other than a traffic or vehicle safety violation?",
        "followupParent": null
    },
    "phase3a.sidebar.investigationopen": {
        "shortText": "Investigation Open",
        "fullText": "What was that investigative question or questions?",
        "followupParent": "phase3a.sidebar.investigationask",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.investigationhelp": {
        "shortText": "Investigation Help",
        "fullText": "Does an officer ask the civilian for assistance or information related to investigating crimes or enhancing safety in their community, such as asking whether they have seen a vehicle or individual of a particular description?",
        "followupParent": null
    },
    "phase3a.sidebar.publicsafetyobject": {
        "shortText": "Public Safety Object",
        "fullText": "Does an officer otherwise attempt to engage the civilian(s) as a partner(s) in a public safety objective, like asking them to report certain things if the civilian(s) observes them? (Note: saying \u201cdrive safely\u201d in closing is not enough.)",
        "followupParent": null
    },
    "phase3a.sidebar.dephomesec": {
        "shortText": "Homeland Security",
        "fullText": "Do the police refer the civilian to the US dept of Homeland Security (e.g., Immigration and Customs Enforcement, Customs and Border Protection)?",
        "followupParent": null
    },
    "phase3a.sidebar.resist": {
        "shortText": "Resist",
        "fullText": "Does the civilian resist any of the officer's physical or verbal requests for compliance?",
        "followupParent": null
    },
    "phase3a.sidebar.resisttype": {
        "shortText": "Resist Type",
        "fullText": "Which type of enforcement are they resisting? (Choose all that apply)",
        "followupParent": "phase3a.sidebar.resist",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.allegemisconduct": {
        "shortText": "Allege Misconduct",
        "fullText": "Does the civilian allege that any of the officers on the scene have committed misconduct?",
        "followupParent": null
    },
    "phase3a.sidebar.complaint": {
        "shortText": "Complaint",
        "fullText": "Does the civilian state that they wish to file a complaint or talk to a supervisor?",
        "followupParent": null
    },
    "phase3a.sidebar.allegetype": {
        "shortText": "Allege Type",
        "fullText": "What type of misconduct does the civilian allege? Choose all that apply",
        "followupParent": "phase3a.sidebar.allegemisconduct",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.allegetypeother": {
        "shortText": "Allege Type Other",
        "fullText": "If \"other\" specify what type of conduct the civilian alleges:",
        "followupParent": "phase3a.sidebar.allegetype",
        "triggerAnswerFromParent": {
            "operation": "in",
            "value": "Speeding"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.allegeresponse": {
        "shortText": "Allege Response",
        "fullText": "Does an officer respond to the misconduct allegation with any of the following? Choose all that apply:",
        "followupParent": "phase3a.sidebar.allegemisconduct",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.handcuff": {
        "shortText": "Handcuff",
        "fullText": "Is the civilian placed in handcuffs?",
        "followupParent": null
    },
    "phase3a.sidebar.arrest": {
        "shortText": "Arrest",
        "fullText": "Is the civilian arrested?",
        "followupParent": null
    },
    "phase3a.sidebar.clarity2": {
        "shortText": "Clarity",
        "fullText": "Is there a time when the officer cannot understand or is having difficulty understanding the civilian(s)?",
        "followupParent": null
    },
    "phase3a.sidebar.greeting": {
        "shortText": "Greeting",
        "fullText": "Does the officer greet the civilian(s)?",
        "followupParent": null
    },
    "phase3a.sidebar.introducename": {
        "shortText": "Introduce Name",
        "fullText": "Does the officer introduce themselves by name?",
        "followupParent": null
    },
    "phase3a.sidebar.introducedept": {
        "shortText": "Introduce Dept",
        "fullText": "Does the officer state the department for which they work?",
        "followupParent": null
    },
    "phase3a.sidebar.apologyoff": {
        "shortText": "Apology",
        "fullText": "Does the officer apologize for anything? (i.e. \u201cSorry for the inconvenience\u201d or \u201cmy fault\u201d)",
        "followupParent": null
    },
    "phase3a.sidebar.thank2": {
        "shortText": "Thank",
        "fullText": "Does the officer thank the civilian(s) at any point in the interaction?",
        "followupParent": null
    },
    "phase3a.sidebar.compliment": {
        "shortText": "Compliment",
        "fullText": "Does the officer compliment the driver for anything? (e.g., \u201a\"You're very organized\" or \u201a\"I like your hat.\")",
        "followupParent": null
    },
    "phase3a.sidebar.anxiousapproach": {
        "shortText": "Anxious Approach",
        "fullText": "Does the officer approach the vehicle anxiously and/or with trepidation?",
        "followupParent": null
    },
    "phase3a.sidebar.cartouch": {
        "shortText": "Car Touch",
        "fullText": "Does the officer touch the car as they approach?",
        "followupParent": null
    },
    "phase3a.sidebar.prior": {
        "shortText": "Prior",
        "fullText": "Prior to initiating communication with the driver, does the officer state for the record why the vehicle was pulled over?",
        "followupParent": null
    },
    "phase3a.sidebar.priorlegalreason": {
        "shortText": "Prior Legal Reason",
        "fullText": "What is the reason for the pullover given?",
        "followupParent": "phase3a.sidebar.prior",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.priorsuspicion": {
        "shortText": "Prior Suspicion",
        "fullText": "Does the officer provide any reason why they believe the civilian may be involved in any crime?",
        "followupParent": null
    },
    "phase3a.sidebar.priorsuspicionreason": {
        "shortText": "Prior Suspicion Reason",
        "fullText": "What is the prior suspicion reason?",
        "followupParent": "phase3a.sidebar.priorsuspicion",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.cameratap": {
        "shortText": "Camera Tap",
        "fullText": "Does the officer ever tap on the camera to show other officers that it is on? (you will hear a tap in the audio and a shake of the screen while aimed at another officer)",
        "followupParent": null
    },
    "phase3a.sidebar.cameramuffle": {
        "shortText": "Camera Muffle",
        "fullText": "Does the officer ever deliberately muffle or cover the camera?",
        "followupParent": null
    },
    "phase3a.sidebar.backup": {
        "shortText": "Back Up",
        "fullText": "Does the officer call for a supervisor, back up, or other units?",
        "followupParent": null
    },
    "phase3a.sidebar.yell2": {
        "shortText": "Yell",
        "fullText": "Does the officer yell at a civilian?",
        "followupParent": null
    },
    "phase3a.sidebar.verbalattack2": {
        "shortText": "Verbal Attack",
        "fullText": "Does the officer insult or verbally attack a civilian?",
        "followupParent": null
    },
    "phase3a.sidebar.deflection": {
        "shortText": "Deflection",
        "fullText": "Does the officer use deflection and redirection techniques?",
        "followupParent": null
    },
    "phase3a.sidebar.hatespeech2": {
        "shortText": "Hate Speech",
        "fullText": "Does the officer use hate speech (e.g., racist, sexist, or homophobic language)?",
        "followupParent": null
    },
    "phase3a.sidebar.hatespeechopen2": {
        "shortText": "Hate Speech Open",
        "fullText": "Can you please explain the situation in which the hate speech was used and why you consider the language to be hate-based?",
        "followupParent": "phase3a.sidebar.hatespeech2",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.officerthreatenviolence": {
        "shortText": "Officer Threaten Violence",
        "fullText": "Does the officer threaten the civilian with violence?",
        "followupParent": null
    },
    "phase3a.sidebar.officerviolencefollowup": {
        "shortText": "Officer Violence Type",
        "fullText": "Is this a verbal threat or physical intimidation?",
        "followupParent": "phase3a.sidebar.officerthreatenviolence",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.weapondrawn": {
        "shortText": "Weapon Drawn",
        "fullText": "Does the officer draw a weapon?",
        "followupParent": null
    },
    "phase3a.sidebar.weapontype2": {
        "shortText": "Weapon Type",
        "fullText": "What kind of weapon does the officer draw?",
        "followupParent": "phase3a.sidebar.weapondrawn",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.interrupt2": {
        "shortText": "Interrupt Officer",
        "fullText": "At any point in the stop, does the officer interrupt or attempt to interrupt a civilian when the civilian is speaking?",
        "followupParent": null
    },
    "phase3a.sidebar.endpositive": {
        "shortText": "End Positive",
        "fullText": "Does the officer end the interaction with a statement with a positive sentiment (e.g., \u201a\"drive safely\",\u201a\"have a good day/night\")?",
        "followupParent": null
    },
    "phase3a.sidebar.concernforsafety": {
        "shortText": "Concern for Safety",
        "fullText": "Does the officer express concern for the civilian's safety (e.g. \u201a\"that was dangerous, please drive safe\" \u201a\"I'm looking out for your safety\")?",
        "followupParent": null
    },
    "phase3a.sidebar.officerforce": {
        "shortText": "Officer Force",
        "fullText": "Does the officer use any force against the civilian(s)?",
        "followupParent": null
    },
    "phase3a.sidebar.officerforcetype": {
        "shortText": "Officer Force Type",
        "fullText": "What type of force?",
        "followupParent": "phase3a.sidebar.officerforce",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.highriskpullover": {
        "shortText": "High Risk Pullover",
        "fullText": "Was this a high risk pullover, which is where the officer orders the driver out of the car before approaching?",
        "followupParent": null
    },
    "phase3a.sidebar.traffic": {
        "shortText": "Traffic",
        "fullText": "Was there heavy traffic?",
        "followupParent": null
    },
    "phase3a.sidebar.weather": {
        "shortText": "Weather",
        "fullText": "Was there any unusual weather that may play a role in the communication during the stop (e.g., raining, windy)?",
        "followupParent": null
    },
    "phase3a.sidebar.background": {
        "shortText": "Background",
        "fullText": "Is there anything else happening in the background or surrounding area of the stop that somehow interfered with the communication of the traffic-stop?",
        "followupParent": null
    },
    "phase3a.sidebar.backgroundtype": {
        "shortText": "Background Type",
        "fullText": "What is happening in the background that can interfere with the traffic stop?",
        "followupParent": "phase3a.sidebar.background",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3a.sidebar.additionalunits": {
        "shortText": "Additional Units",
        "fullText": "Were there any additional units present in the stop?",
        "followupParent": null
    },
    "phase3a.sidebar.additionalarrive": {
        "shortText": "Additional Units Arrive",
        "fullText": "Do any additional units arrive on the scene after this unit?",
        "followupParent": null
    },
    "phase3a.sidebar.additionaltype": {
        "shortText": "Additional Units Type",
        "fullText": "What type of additional units arrive? (Choose all that apply)",
        "followupParent": "phase3a.sidebar.additionalarrive",
        "triggerAnswerFromParent": {
            "operation": "eq",
            "value": "Yes"
        },
        "directedFrom": Directed.OWN
    },
    "phase3b.sidebar.respect": {
        "shortText": "Overall Respect",
        "fullText": "Overall, how would you evaluate the {{label_type}} respectfulness during this stop?",
        "low": "Very Disrespectful",
        "high": "Very Respectful",
        "followupParent": null
    },
    "phase3b.sidebar.respectmultiselectpolice": {
        "shortText": "Overall Respect Multiselect",
        "fullText": "Can you please choose the specific situations and reasoning that led to your overall respect rating of the police officer/civilian from the following options?",
        "followupParent": null
    },
    "phase3b.sidebar.respectmultiselectcivilian": {
        "shortText": "Overall Respect Multiselect",
        "fullText": "Can you please choose the specific situations and reasoning that led to your overall respect rating of the police officer/civilian from the following options?",
        "followupParent": null
    },
    "phase3b.sidebar.respectopen": {
        "shortText": "Overall Respect Open",
        "fullText": "Can you please describe the specific situations and reasoning that led to your overall respect rating of the {{label_type}}?",
        "followupParent": null
    },
    "phase3b.sidebar.overallobjectivesummary": {
        "shortText": "Overall Objective Summary",
        "fullText": "How would you summarize the events of this stop in a court of law? Please write 3-6 complete sentences.",
        "followupParent": null
    },
    "phase3b.sidebar.overallsubjectivesummary": {
        "shortText": "Overall Subjective Summary",
        "fullText": "How would you describe this stop to a friend? Please write 3-6 complete sentences.",
        "followupParent": null
    },
    "phase3b.sidebar.legitimacy": {
        "shortText": "Legitimacy  ",
        "fullText": "Taken in its entirety, does this stop represent legitimate policing?",
        "low": "Very Illegitimate",
        "high": "Very Legitimate ",
        "followupParent": null
    },
    "phase3b.sidebar.legitimacyopen": {
        "shortText": "Legitimacy Open",
        "fullText": "Please explain your reasoning in 3-6 sentences.",
        "followupParent": null
    }
};

const fillTextTemplate = (template: string, data: { [key: string]: string }) => {
    return Object.keys(data).reduce((prev, key) => prev.replaceAll(`{{${key}}}`, data[key]), template);
};

export const toDisplay_phase3 = (
    attrSpec: any,
    jobAttributeSpec: any,
    attrVals: any,
    jobAttributes: any,
    attr: any,
    people: any[],
): boolean => {
    const attrConf = config_phase3[attr.name];
    if (!attrConf) {
        return false;
    }

    if (attrConf.followupParent === null) {
        return true;
    }

    const parentAttrName = attrConf.followupParent;

    const parentAttrConf = config_phase3[parentAttrName];
    if (!parentAttrConf) {
        return false;
    }

    if (attrConf.directedFrom === Directed.OWN) {
        const parentAttrId = attrSpec.filter((attr: any) => attr.name === parentAttrName)[0]?.id;
        // return attrVals[parentAttrId] === attrConf.triggerAnswerFromParent;
        if (!attrConf.triggerAnswerFromParent) {
            return false;
        }
        return isTriggerOptionSet(attrConf.triggerAnswerFromParent, attrVals[parentAttrId]);
    }

    if (
        people.some((person) => {
            const parentAttrId = person.label.attributes.filter((attr: any) => attr.name === parentAttrName)[0]?.id;
            if (!attrConf.triggerAnswerFromParent) {
                return false;
            }
            return isTriggerOptionSet(attrConf.triggerAnswerFromParent, person.attributes[parentAttrId]);
        })
    ) {
        return true;
    }

    if (
        jobAttributeSpec.some(
            (attr: any) =>
                attr.name === parentAttrName &&
                attrConf.triggerAnswerFromParent &&
                isTriggerOptionSet(attrConf.triggerAnswerFromParent, jobAttributes[attr.id]),
        )
    ) {
        return true;
    }

    return false;
};

export const isTriggerOptionSet = (triggerOptionconfig_V2: TriggerOption, value: string | boolean | number) => {
    let operator = triggerOptionconfig_V2.operation;
    let triggerValue = triggerOptionconfig_V2.value;
    switch (operator) {
        case 'eq':
            return value === triggerValue;
        case 'gt':
            return value > triggerValue;
        case 'in':
            return (value + '').split(',').includes(triggerValue +'')
    }
};

export const getFilledFullText_phase3 = (attrName: string, labelName: string) => {
    const label_type = labelName.startsWith('person:Police') ? 'officer' : 'civilian';
    const opposing_label_type = labelName.startsWith('person:Police') ? 'civilian' : 'officer';
    return fillTextTemplate(config_phase3[attrName]?.fullText || '', {
        label_type,
        opposing_label_type,
    });
};
